// extracted by mini-css-extract-plugin
export default {"textWidth":"CenteredTexts_textWidth__5G8lB","centeredContainer":"CenteredTexts_centeredContainer__e1l7e"};